import { useCallback } from 'react'
import { useSessionStorage } from '~/hooks/useSessionStorage'

export const useTutorial = () => {
  const { value: closed, set: setClosed } = useSessionStorage(
    'hide_coordinate_detail_imagesearch_tutorial'
  )
  const close = useCallback(() => {
    if (closed) return
    setClosed(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setClosed])
  return { closed, close }
}
